/*
 * @Author: tuzhijing tuzhijing@wiz.top
 * @Date: 2024-01-22 14:08:49
 * @LastEditors: tuzhijing tuzhijing@wiz.top
 * @LastEditTime: 2024-01-25 11:25:22
 * @FilePath: \wiz-3d-visualization\src\modules\visualization-cockpit-tongre\components\business\twoVote\config.js
 * @Description: 
 */

/**
 * @description 金属BIM childe
 * @param {Array} tableHead
 * @param {string} api
 */
export const operationConfig = {
  pipelineSecondaryLedger: {
    tableHead: [
      { label: '票类型', prop: 'ticketTypeName', width: 100 }, // 父组件赋值
      { label: '编号', prop: 'taskNo', width: 100 },
      { label: '名称', prop: 'taskName', width: 100 },
      { label: '创建时间', prop: 'ticketCreateTime', width: 100 },
      { label: '票状态', prop: 'stateDescription', width: 100 },
      // { label: '操作人', prop: '', width: 100 },
      // { label: '监护人', prop: '', width: 80 },
    ],
    api: '/api/wfmodule/ticketCurrent/getTicketCurrentList',
  },
}

export const workConfig = {
  pipelineSecondaryLedger: {
    tableHead: [
      { label: '工作票状态', prop: 'ticketState', width: 100 }, // 父组件赋值
      { label: '工作票号', prop: 'ticketNo' },
      { label: '设备编码', prop: 'deviceCodes' },
      { label: '设备名称', prop: 'deviceNames' },
      { label: '工作内容', prop: 'workContent' },
    ],
    api: '/api/wfmodule/workTickets/getWorkTicketList',
  },
}

export const detailsConfig = {
  pipelineSecondaryLedger: {
    tableHead: [
      { label: '工作票状态', prop: 'fromState', width: 130 }, // 父组件赋值
      { label: '工作票号', prop: 'ticketId', width: 130 },
      { label: '设备编码', prop: 'deviceIdentifier', width: 130 },
      { label: '设备名称', prop: 'deviceName', width: 160 },
      { label: '工作内容', prop: 'operationModeName', width: 160 },
    ],
    api: '/api/wfmodule/ticketCurrent/getTicketCurrent',
  },
}
